import React from 'react';

import { MUIModal } from 'Components/Base';
import { FeedbackLikeForm, FeedbackReportComplete } from 'Components/Feedback';

const FeedbackLikeModal = ({
  isSuccess,
  loading,
  options,
  onSubmit,
  onCloseModal,
  onOpenModal,
  toggleComponent,
}) => {
  return (
    <MUIModal
      toggleComponent={React.isValidElement(toggleComponent) && toggleComponent}
      modalStyle={{ padding: '36px', borderRadius: '16px', maxWidth: '340px' }}
      onOpenModal={onOpenModal}
      onCloseModal={onCloseModal}
    >
      {(openModal, closeModal) => {
        if (isSuccess) {
          return (
            <FeedbackReportComplete
              onContinue={closeModal}
              variant={FeedbackReportComplete.VARIANTS.LIKE}
            />
          );
        }
        return (
          <FeedbackLikeForm
            loading={loading}
            feedbackOptions={options}
            onBack={closeModal}
            onSubmit={onSubmit}
          />
        );
      }}
    </MUIModal>
  );
};

export default FeedbackLikeModal;
